// MEO landmark ads (Phase 1, Step 4-6, 2026-05-01):
// business dashboard CV 集計用 MobX store。
// + T1-A R1 (2026-05-06): 月次レポートタブ用の reports/landmarks fetch を追加。

import { BusinessDashboardApi, MonthlyMeoReportsApi } from '@/apis';
import { ResponseData } from '@/types/http';
import { flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';

export interface MonthlyMeoReportItem {
    id: number,
    landmark_id: number,
    year_month: string,
    payload: any,
    email_sent_at: string | null,
    created_at: string
}

export interface MonthlyMeoLandmark {
    id: number,
    name: string,
    sponsor_tier: string,
    sponsor_user_id: number | null
}

export interface MonthlyMeoReportsData {
    landmarks: MonthlyMeoLandmark[],
    reports: MonthlyMeoReportItem[],
    months_back: number
}

export default class BusinessDashboardStore extends BaseStore {
    summary: any = null;
    loading: boolean = false;
    api: BusinessDashboardApi;

    monthlyReportsData: MonthlyMeoReportsData | null = null;
    monthlyReportsLoading: boolean = false;
    monthlyReportsApi: MonthlyMeoReportsApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            summary: observable,
            loading: observable,
            monthlyReportsData: observable,
            monthlyReportsLoading: observable,
            fetchSummary: flow.bound,
            fetchMonthlyReports: flow.bound
        });
        this.api = new BusinessDashboardApi();
        this.monthlyReportsApi = new MonthlyMeoReportsApi();
    }

    *fetchSummary(payload: { from: string, to: string }) {
        try {
            this.loading = true;
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.fetchSummary, payload);
            if (res?.ok) {
                this.summary = res.data;
            }
            return res;
        } catch (_e) {
            return null;
        } finally {
            this.loading = false;
        }
    }

    *fetchMonthlyReports() {
        try {
            this.monthlyReportsLoading = true;
            const res: ResponseData = yield this.rootStore.apiStore.call(
                this.monthlyReportsApi,
                this.monthlyReportsApi.fetchList
            );
            if (res?.ok) {
                this.monthlyReportsData = res.data as MonthlyMeoReportsData;
            }
            return res;
        } catch (_e) {
            return null;
        } finally {
            this.monthlyReportsLoading = false;
        }
    }
}
